import { render, staticRenderFns } from "./inf-internet.vue?vue&type=template&id=58b83af6&scoped=true"
import script from "./inf-internet.vue?vue&type=script&lang=js"
export * from "./inf-internet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b83af6",
  null
  
)

export default component.exports